/**
 * @generated SignedSource<<20d2c6664a98d710acaacb2a0ebf7915>>
 * @relayHash 1b4be90193f2ea7107cf30060b2cfd11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9cd044c245a3dde3005208575bee53c2d0bc1c5cb1ff3385e62dc5ccabf2f0e7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPickerAtlasQuery$variables = {
  cloudId: string;
};
export type ProjectPickerAtlasQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPicker_Atlas">;
};
export type ProjectPickerAtlasQuery = {
  response: ProjectPickerAtlasQuery$data;
  variables: ProjectPickerAtlasQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ProjectPickerAtlasQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectPicker_Atlas"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPickerAtlasQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "orgId"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              (v2/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "concreteType": "TownsquareUnshardedWorkspaceSummaryConnection",
        "kind": "LinkedField",
        "name": "townsquareUnsharded_allWorkspaceSummariesForOrg",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUnshardedWorkspaceSummaryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareUnshardedWorkspaceSummary",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "cloudId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "concreteType": "TownsquareUnshardedUserCapabilities",
                    "kind": "LinkedField",
                    "name": "userCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareUnshardedCapability",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "capability"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "capabilityContainer"
                          }
                        ]
                      }
                    ]
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9cd044c245a3dde3005208575bee53c2d0bc1c5cb1ff3385e62dc5ccabf2f0e7",
    "metadata": {},
    "name": "ProjectPickerAtlasQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2948919b46c076b76def512ee4c32b35";

export default node;
